<section class="xs:p-3 xs:bg-grey-light-4" data-test="bookings">
  <h2 class="title-5 mb-2 xs:mb-3">
    {{ 'activity.timeslots.title' | translate }}
  </h2>
  <p
    class="mb-4 text-vtmn-play-content-quiet text-xs font-medium"
    *ngIf="activity?.isBms && isExternal"
  >
    {{
      'activity.timeslots.bmsPrevention'
        | translate: { organizerName: organizerName }
    }}
  </p>
  <div class="-mx-3 bg-grey-light-4 xs:mx-0 xs:p-0 xs:bg-transparent lg:mt-0">
    <div
      [ngClass]="containerModifier"
      class="activity-component__timeslot-container xs:space-y-3"
    >
      <app-timeslot
        *ngFor="let timeslot of timeslots; let index = index"
        [timeslot]="timeslot"
        [activity]="activity"
        class="activity-component__timeslot-item"
        [ngClass]="timeslotSizeClass"
        [containerClass]="'p-3'"
        data-test="timeslots"
      >
        <ng-container price-badge-right>
          <app-timeslot-price-preview
            [timeslot]="timeslot"
            [isBg]="isBg"
          ></app-timeslot-price-preview>
        </ng-container>

        <ng-container
          cta
          [ngTemplateOutlet]="buttons?.toArray()[index]?.itemTemplate"
        ></ng-container>
      </app-timeslot>
    </div>

    <div
      class="px-3 pb-3 xs:p-0 xs:mt-3 md:flex md:justify-end"
      *ngIf="hasSeeMoreUrl"
    >
      <a
        app-vtmn-play-button
        class="align-bottom w-full md:w-auto lg:w-full"
        [type]="ctaButtonType.Button"
        [variant]="vtmnPlayButtonVariant.PRIMARY"
        [shape]="vtmnPlayButtonShape.SQUARED"
        [routerLink]="seeMoreUrl"
      >
        {{ 'activity.timeslots.button' | translate }}
      </a>
    </div>
  </div>

  <app-pagination-buttons
    *ngIf="hasPagination"
    [hasLoadMoreButton]="hasLoadMoreButton"
    (loadMore)="loadMore.emit()"
    class="block mt-6"
  >
  </app-pagination-buttons>
</section>
